<template>
  <p>
    {{ questions }}
  </p>
</template>

<script>
export default {
  data: function() {
    return {
      images: {
        logo: require("../assets/logo.png")
      },
      questions: "Sample Questions"
    };
  },
  created() {
    if (!this.$store.getters.get_login) {
      this.$router.push({
        path: "/signin"
      });
    }
    //if (this.questions == "") this.getDataFromFirebase();
  },
  methods: {
    /*     getDataFromFirebase: function() {
      console.log("Calling firebase api");
      var db = firebase.firestore();
      //console.log(db);
      var ref = db.collection("tests").doc("test-1-en");
      //console.log(ref);
      var vm = this;
      ref
        .get()
        .then(function(doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            vm.questions = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
            vm.questions = "No such document!";
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
          vm.questions = "Error getting document!";
        });
    } */
  }
};
</script>
<style scoped>
p {
  padding: 50px;
}
</style>
